import {
  getUserDisplayName,
  getUserInitial,
  type UserDisplayData,
} from '../../lib/utils/userDisplay';

interface UserAvatarProps {
  user: UserDisplayData | null;
  size?: 'sm' | 'md' | 'lg';
  bgClass?: string;
  textClass?: string;
}

const SIZE_CLASSES = {
  sm: 'h-8 w-8 text-sm',
  md: 'h-10 w-10 text-base',
  lg: 'h-20 w-20 text-2xl',
} as const;

export function UserAvatar({
  user,
  size = 'md',
  bgClass = 'bg-sky-100 dark:bg-sky-500/20',
  textClass = 'text-sky-600 dark:text-sky-400',
}: UserAvatarProps) {
  const displayName = getUserDisplayName(user);

  return (
    <div
      className={`${SIZE_CLASSES[size]} rounded-full ${bgClass} flex items-center justify-center shrink-0`}
      title={displayName}
    >
      <span className={`${textClass} font-semibold`}>{getUserInitial(user)}</span>
    </div>
  );
}
